import { useState } from 'react';
import { restoreReq } from '../../../../../api/auth/restore-request';
import { useRequest } from '../../../../hooks/use-request';

export function useViewModel() {
  const [phone, setPhone] = useState<string>('');
  const { action, isLoading } = useRequest();

  const passwordResetSubmitHandler = async (data: { phone: string }) =>
    action(async () => {
      const resp = await restoreReq(data.phone);
      if (!resp.success) {
        throw new Error(resp);
      }

      setPhone(data.phone);
    });

  return {
    passwordResetSubmitHandler,
    showComplete: !!phone.length,
    phone,
    isLoading,
  };
}
